export default "__VITE_ASSET__7356eccf__"